<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="tipo_instrumento.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Descrição:">
      <b-form-textarea
        v-model="tipo_instrumento.descricao"
        placeholder="Descrição"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    tipo_instrumento: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("tipos_instrumentos", ["tipo_instrumento"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.tipo_instrumento[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.tipo_instrumento.$touch();
      return !this.$v.tipo_instrumento.$anyError;
    },
  },
  created() {},
};
</script>
